<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
                        <el-row v-show="!showAcademicInfo">
                            <el-col>
                                <span class="cs-title">学生列表</span>
                                <studyAbroadStudentList :isActive="true" @viewStudyAbroadProfile="onViewStudyAbroadProfile" />
                            </el-col>
                        </el-row>
                        <academicInfo v-if="showAcademicInfo" :dataIn="academicInfoData" @close="onAcademicInfoClose"/>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>


<script>
import navigator from "../../components/navigator";
import academicInfo from "../../components/studyAbroad/academicInfo/main";
import studyAbroadStudentList from "../../components/studentList/studyAbroadStudentList";

export default {
    components: {
        navigator,
        studyAbroadStudentList,
        academicInfo
    },
    data() {
        return {
            showAcademicInfo: false,
            academicInfoData: null
        };
    },
    created() {
        
    },
    methods: {
        onAcademicInfoClose(){
            this.showAcademicInfo = false;
        },
        onViewStudyAbroadProfile(studentId){
            this.academicInfoData = {
                studentId: studentId,
            };
            this.showAcademicInfo = true;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/studyAbroad/studentInfoList.vue